import { render, staticRenderFns } from "./crm-paymentTypes.vue?vue&type=template&id=2bf433d2&"
import script from "./crm-paymentTypes.vue?vue&type=script&lang=js&"
export * from "./crm-paymentTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports